import React, { useCallback, useState } from 'react'
import { useMutation } from '@apollo/client'
import { mergeLeft } from 'merge-left-utils'

import ValidatorModel from './validators/EmailPasswordAuthFormValidatorModel'

import { Form, Button, Notification } from 'rsuite'

import { GQL_MUTATION_LOGIN } from './graphql'
import { makeGraphQLErrorNotification } from '../../helpers/notification'

export interface EmailPasswordAuthFormProps {
  onAuth?: Function
}

export interface EmailPasswordAuthFormCredentialsShape {
  email: string
  password: string
}

const DEFAULT_CREDENTIALS: EmailPasswordAuthFormCredentialsShape = {
  email: '',
  password: ''
}

export default function EmailPasswordAuthForm ({
  onAuth
}: EmailPasswordAuthFormProps) {
  const [ credentials, setCredentials ] =
    useState<EmailPasswordAuthFormCredentialsShape>(DEFAULT_CREDENTIALS)

  const [ login, { loading } ] = useMutation(GQL_MUTATION_LOGIN)

  const handleAuthFormSubmit = useCallback(
    (isOk = false) => {
      if (isOk) {
        login({
          variables: {
            credentials: {
              email:credentials.email.toLowerCase(),
              password: credentials.password 
            }
          }
        })
          .then(({ data: { login: accountInfo } }) => {
            onAuth?.(accountInfo)
          })
          .catch(makeGraphQLErrorNotification('Ошибка входа'))
      }
    },
    [ login, credentials, onAuth ]
  )

  const handleAuthFormChange = useCallback((inputData) => {
    setCredentials((credentials) => mergeLeft(credentials, inputData))
  }, [])

  return (
    <Form
      onSubmit={handleAuthFormSubmit}
      model={ValidatorModel}
      formValue={credentials}
      onChange={handleAuthFormChange}
    >
      <Form.Group>
        <Form.Control name="email" placeholder="Ваш e-mail" />
      </Form.Group>
      <Form.Group>
        <Form.Control
          type="password"
          name="password"
          placeholder="Ваш пароль"
        />
      </Form.Group>

      <Button
        loading={loading}
        disabled={loading}
        type="submit"
        color="green"
        appearance="primary"
        block
      >
        Войти
      </Button>
    </Form>
  )
}
